module.exports = __webpack_public_path__ + "img/d2affa3.jpg";